export default "__VITE_ASSET__WmS_DOsQ__";